module.exports = __webpack_public_path__ + "img/422144687.7ff1bc55.jpg";